export const ACTION_RESET = 'FETCH_VIDEODATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_VIDEODATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_VIDEODATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_VIDEODATALIST_ERROR';
